export default __webpack_public_path__ + "static/media/lock.4c9ccf9b.svg";